import React from 'react';
import { DollarSignIcon } from 'lucide-react';
export function CourseCosts() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3009">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3010">
        <div className="mb-12" data-id="element-3011">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-3012">
            Course Costs
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-3013">
            <div className="p-4 border-b flex items-center gap-3" style={{
            backgroundColor: '#1e3d2f',
            borderColor: '#ede9e0'
          }} data-id="element-3014">
              <DollarSignIcon size={20} style={{
              color: '#c8a84b'
            }} data-id="element-3015" />
              <h3 className="text-base font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#ffffff'
            }} data-id="element-3016">
                Course Tuition
              </h3>
            </div>
            <div className="overflow-x-auto" data-id="element-3017">
              <table className="w-full text-left border-collapse" data-id="element-3018">
                <thead data-id="element-3019">
                  <tr style={{
                  backgroundColor: 'rgba(30,61,47,0.04)'
                }} data-id="element-3020">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3021">
                      Membership
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#1e3d2f',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-3022">
                      Cost
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-3023">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-3024">
                    <td className="p-4 font-medium text-gray-800" data-id="element-3025">
                      FLSC Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-3026">$85</td>
                  </tr>
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-3027">
                    <td className="p-4 font-medium text-gray-800" data-id="element-3028">
                      Non-Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-3029">$140</td>
                  </tr>
                  <tr data-id="element-3030">
                    <td colSpan={2} className="p-4 text-sm text-gray-500 bg-gray-50 italic" data-id="element-3031">
                      No refunds on course tuition within two weeks of class.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}